import http from './httpService';

export function getAllRiskMitigationModes() {
  return http.get(`/risk-mitigation-modes`);
}

export function createRiskMitigationMode(payload) {
  return http.post(`/risk-mitigation-modes`, payload);
}

export function updateRiskMitigationMode(payload) {
  return http.put(`/risk-mitigation-modes`, payload);
}

export function deleteRiskMitigationMode(id) {
  return http.delete(`/risk-mitigation-modes/${id}`);
}
